document.querySelectorAll(".tab_content").forEach(function(tabContent) {
  tabContent.style.display = "none";
});
document.querySelectorAll(".tab_content")[0].style.display = "block";
document.querySelectorAll("ul.tabs li").forEach(function(tab) {
  tab.addEventListener("click", function() {
    document.querySelectorAll(".tab_content").forEach(function(tabContent) {
      tabContent.style.display = "none";
    });
    var activeTab = this.getAttribute("rel");
    document.getElementById(activeTab).style.display = "block";
    document.querySelectorAll("ul.tabs li").forEach(function(tab2) {
      tab2.classList.remove("active");
    });
    this.classList.add("active");
    document.querySelectorAll(".tab_drawer_heading").forEach(function(drawerHeading) {
      drawerHeading.classList.remove("d_active", "is-open");
    });
    document.querySelector(".tab_drawer_heading[rel^='" + activeTab + "']").classList.add("d_active", "is-open");
  });
});
document.querySelectorAll(".tab_drawer_heading").forEach(function(drawerHeading) {
  drawerHeading.addEventListener("click", function() {
    var d_activeTab = this.getAttribute("rel");
    if (this.classList.contains("d_active")) {
      this.classList.remove("d_active", "is-open");
      document.getElementById(d_activeTab).style.display = "none";
    } else {
      this.classList.add("d_active", "is-open");
      document.getElementById(d_activeTab).style.display = "block";
    }
  });
});
document.querySelectorAll("ul.tabs li").forEach(function(tab, index, array) {
  if (index === array.length - 1) {
    tab.classList.add("tab_last");
  }
});
var descriptionOverflowContainer = document.querySelector(
  ".description-overflow-container"
);
var showMoreButton = document.querySelector(".show-more");
if (descriptionOverflowContainer.offsetHeight < 190) {
  showMoreButton.style.display = "none";
  descriptionOverflowContainer.style.paddingBottom = "0";
}
showMoreButton.addEventListener("click", function(event) {
  if (descriptionOverflowContainer.classList.contains("open")) {
    descriptionOverflowContainer.classList.remove("open");
    document.getElementById("show-less").classList.remove("show");
    document.getElementById("show-more").classList.add("show");
    descriptionOverflowContainer.style.maxHeight = "420px";
    window.scrollTo({
      top: document.getElementById("tab_container").offsetTop - 110,
      behavior: "smooth"
    });
  } else {
    descriptionOverflowContainer.classList.add("open");
    var overflowContainerHeight = document.querySelector(
      ".description-overflow-container--inner"
    ).offsetHeight;
    document.getElementById("show-more").classList.remove("show");
    document.getElementById("show-less").classList.add("show");
    descriptionOverflowContainer.style.maxHeight = overflowContainerHeight + "px";
  }
  event.preventDefault();
});
